export default class CollectionModal {
    constructor(options) {
        this.dom = {
            el: document.querySelector("#smallModal")
        };

        this.collection_bar = options.collection_bar;

        this.assign();
        this.events();
    }

    assign() {
        this.dom.add_collection = this.dom.el.querySelector(
            "#add-to-collection-modal"
        );
        this.dom.add_cart = this.dom.el.querySelector("#add-to-cart-modal");
        this.dom.close = this.dom.el.querySelector(".close-button");

        this.dom.collection_bar_button = document.querySelector(".collection-bar-button");
        this.dom.finished = this.dom.el.querySelector("#closeButton");
        this.dom.select_button = document.querySelector(".samples-button");

        this.dom.icon_collection =
            "<svg class='collection-icon'><use xlink:href='#collection-icon'></svg>";
        this.dom.icon_spin = "<i class='fas fa-spinner fa-spin'></i>";
        this.dom.icon_cart =
            "<i class='fas fa-shopping-cart'></i><i class='fas fa-spinner fa-spin'></i>";
        this.dom.icon_check = '<span class="fas fa-check">&nbsp;</span>';

        this.dom.add_to_collection = this.dom.el.querySelector(
            "#add-to-collection-modal"
        );
        this.dom.add_to_cart = this.dom.el.querySelector("#add-to-cart-modal");
    }

    close_modal() {
        this.collection_bar.close();
        this.collection_bar.unselect_tabs();
        this.close();
        this.dom.select_button.innerHTML =
            "<i class='fas fa-shopping-cart'></i> Select swatches";
        this.dom.select_button.classList.remove("active");

        this.dom.add_to_collection.classList.remove("success");
        this.dom.add_to_cart.classList.remove("success");

        this.dom.add_to_collection.innerHTML =
            '<svg class="collection-icon"><use xlink: href="#collection-icon"></svg>Add to collection';
        this.dom.add_to_cart.innerHTML =
            '<i class="fas fa-shopping-cart"></i>Add to sample cart';
        this.dom.finished.innerHTML = 'Discard selection';
    }

    events() {
        this.dom.close.addEventListener("click", () => {
            this.close();
        });

        if (this.dom.collection_bar_button) {
            this.dom.collection_bar_button.addEventListener("click", () => {
                if (
                    this.dom.add_cart.classList.contains("success") ||
                    this.dom.add_collection.classList.contains("success")
                ) {
                    this.close_modal();
                    document.body.classList.remove("small-modal");
                } else {
                    // Should trigger via event
                    document.body.classList.add("small-modal");
                }
            });
        }

        this.dom.finished.addEventListener("click", () => {
            this.close_modal();
        });

        this.dom.add_collection.addEventListener("click", (e) => {
            if (!e.target.classList.contains("noswatches")) {
                this.add_collection();
            } else {
                //console.log("n");
            }
        });

        this.dom.add_cart.addEventListener("click", (e) => {
            if (!e.target.classList.contains("noswatches")) {
                this.add_cart();
            } else {
                //console.log('m')
            }
        });
    }

    add_collection() {
        this.dom.add_collection.innerHTML = `${
            this.dom.icon_spin
        } Adding to collection`;

        this.collection_bar.add_collection().then(() => {
            this.dom.add_collection.innerHTML = `${
                this.dom.icon_check
            } Added to collection`;
            this.dom.add_collection.classList.remove("loading");
            this.dom.add_collection.classList.add("success");
            this.dom.finished.innerHTML = `Done`;
        });
    }

    add_cart() {
        this.dom.add_cart.innerHTML = `${this.dom.icon_spin} Adding to sample cart`;

        // Need to recieve a promise here
        this.collection_bar.add_cart();
        this.dom.add_cart.innerHTML = `${this.dom.icon_check} Added to sample cart`;
        this.dom.add_cart.classList.remove('loading');
        this.dom.add_cart.classList.add("success");
        this.dom.finished.innerHTML = `Done`;
    }

    open() {
        document.body.classList.add("small-modal");
    }

    close() {
        document.body.classList.remove("small-modal");
    }
}
